import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  distancias: [],
  loading: false,
  total: undefined,

  nuevoOpen: false,
  editarOpen: false,
  selectedDistancia: undefined
}

export const filialesDistanciasSlice = createSlice({
  name: 'filialesDitancias',
  initialState,
  reducers: {
    setDistancias: (state, { payload }) => {
      state.distancias = payload
    },
    setTotal: (state, { payload }) => {
      state.total = payload
    },
    setLoading: (state, { payload }) => {
      state.loading = payload
    },
    openNuevo: (state) => {
      state.nuevoOpen = true
    },
    closeNuevo: (state) => {
      state.nuevoOpen = false
    },
    openEditar: (state, { payload }) => {
      state.editarOpen = true
      state.selectedDistancia = payload
    },
    closeEditar: (state) => {
      state.editarOpen = false
      state.selectedDistancia = undefined
    },
  },
})

export const filialesDistanciasActions = filialesDistanciasSlice.actions

export default filialesDistanciasSlice.reducer